/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import axios from 'axios'
import { GoogleLogin } from 'react-google-login';
import SingleDay from './pages/SingleDay'
import Dashboard from './pages/Dashboard'
import MakeEmployee from './pages/MakeEmployee'
import WeekSchedule from './pages/WeekSchedule'
import InvoiceWork from './pages/InvoiceWork'
import Statistics from './pages/Statistics'
import HomeTwo from './pages/HomeTwo'
import DriverDocuments from './pages/DriverDocuments'
import Driver from './pages/Driver'
import Forms from './pages/Forms'
import DocumentsForVerification from './pages/DocumentsForVerification'
import DriverComplianceCheck from './pages/DriverComplianceCheck'
import CreateManager from './pages/CreateManager'
import Compliance from './pages/Compliance'
import RentalVanTracker from './pages/RentalVanTracker'
import CompanyVans from './pages/CompanyVans'
import logo from './images/newLogo.png'
import Summary from './pages/Summary'
import Reports from './pages/Reports'
import './App.scss';
import Home from './pages/home'
import {
  BrowserRouter as Router,
  Route,
  Redirect
} from 'react-router-dom';

var myInterval

// eslint-disable-next-line no-extend-native
Date.prototype.getWeek = function () {
  var firstDate = new Date(this.getFullYear(), 0, 1)
  if (this.getFullYear() === 2021) {
      return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
  } else {
      return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
  }
}

var CryptoJS = require("crypto-js");
async function putNext(url = '', data={}) {
  let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
  let originalText = bytes.toString(CryptoJS.enc.Utf8);

  const response = await fetch(url, {
      method: 'PUT', 
      mode: 'cors', 
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${originalText}`
      },
      body: JSON.stringify(data)
  });
  return response ? response.json() : console.log('no reponse')
};

// make an object for the user outside the component
let userObj = {
  name: '',
  id: '',
  email: '',
  logOut: [],
  super: false,
  lat: 0,
  long: 0
}

// handle the logout section
// document.addEventListener('mouseleave', e => {
// //   // window.open('http://localhost:3000')

//   // console.log('dont look here :D')
//   if (navigator.geolocation) {
//     console.log('>   <')
//     console.log('  ^ ')
//     console.log('-----')
//     console.log('rawr, stay of here!')
//     // console.log(navigator.geolocation.getCurrentPosition(showPosition))
//   }

//   // function showPosition(position) {
//   //   console.log("Latitude: " + position.coords.latitude +
//   //   "Longitude: " + position.coords.longitude)
//   // }
// //   let theDate = new Date()
// //   let theTime = `${theDate.getHours()}:${theDate.getMinutes()}:${theDate.getSeconds()}`
// //   let localArray = []
// //   if (userObj.logOut.length > 0) {
// //     localArray = [...userObj.logOut, theTime]
// //   } else {
// //     localArray = [theTime]
// //   }
// //   userObj.logOut = localArray
// //   if (!userObj.super) {
// //     if (userObj.id) {
// //       putNext(`https://backendpajamas.herokuapp.com/trackeradditions/${userObj.id}/`, {
// //         logOut_time: localArray
// //       }).then( response => { 
// //         console.log(response)
// //       })
// //     }
// //   }
// })

const App = () => { 
  useEffect( () => {
    axios.get('https://geolocation-db.com/json/344ec440-6bfc-11eb-a0c0-b5dee9e67313').then( response => {
      if (response.status === 200) {
        userObj.lat = response.data.latitude
        userObj.long = response.data.longitude
      }
    })
  }, [])

    // handling checking for managers to change and days to lock
    useEffect( () => {
      setTimeout(() => {
        async function getData(url = '') {
          let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
          let originalText = bytes.toString(CryptoJS.enc.Utf8);
          const response = await fetch(url, {
            method: 'GET', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Token ${originalText}`
            },
          });
          return response ? response.json() : console.log('no reponse')
        }; 
        async function postData(url = '', data = {}) {
          let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
          let originalText = bytes.toString(CryptoJS.enc.Utf8);
          const response = await fetch(url, {
              method: 'POST', 
              mode: 'cors',
              cache: 'no-cache',
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Token ${originalText}`
              },
              body: JSON.stringify(data)
              });

          return response ? response.json() : console.log('no reponse')
      };
        async function putData(url = '', data = {}) {
          let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
          let originalText = bytes.toString(CryptoJS.enc.Utf8);
          const response = await fetch(url, {
              method: 'PUT', 
              mode: 'cors',
              cache: 'no-cache',
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Token ${originalText}`
              },
              body: JSON.stringify(data)
              });

          return response ? response.json() : console.log('no reponse')
      };
        async function deleteData(url = '') {
          let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
          let originalText = bytes.toString(CryptoJS.enc.Utf8);
          const response = await fetch(url, {
            method: 'DELETE', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Token ${originalText}`
            },
          });
        }; 
        clearInterval(myInterval)
        const timeFunction = () => {
            let setTime = () => {
              console.log("checking data")
              getData('https://backendpajamas.herokuapp.com/eighthour/').then( response => {
                if (response) {
                  response.results.forEach( ele => {
                    // handle the daily service
                    if (ele.locktype === 'https://backendpajamas.herokuapp.com/dailyserviceoverridetwo/') {
                      let timeDifference = new Date().getTime()-new Date(ele.current_date).getTime()
                      if (timeDifference > 360000*10*8) {
                        getData('https://backendpajamas.herokuapp.com/dailyservicelocktwo/').then( response => {
                          getData('https://backendpajamas.herokuapp.com/dailyserviceoverridetwo/').then( responseOverride => {
                              let overrideBool = false
                              responseOverride.results.forEach( date => {
                                  if ( date.date === ele.date) {
                                    deleteData(`https://backendpajamas.herokuapp.com/dailyserviceoverridetwo/${date.service_id}/`)
                                  }
                              })
                              postData('https://backendpajamas.herokuapp.com/dailyservicelocktwo/', {
                                date: ele.date,
                              }).then( responseFinal => {
                                deleteData(`https://backendpajamas.herokuapp.com/eighthour/${ele._id}/`)
                              })
                          })
                      })
                      }
                    }
      
                    // handle the rental van tracker
                    if (ele.locktype === 'https://backendpajamas.herokuapp.com/rentalvanoverride/') {
                      let timeDifference = new Date().getTime()-new Date(ele.current_date).getTime()
                      if (timeDifference > 360000*10*8) {
                        getData('https://backendpajamas.herokuapp.com/rentalvanoverride/').then( response => {
                          getData('https://backendpajamas.herokuapp.com/rentallock/').then( responseOverride => {
                              let overrideBool = false
                              responseOverride.results.forEach( date => {
                                  if ( date.date === ele.date) {
                                    deleteData(`https://backendpajamas.herokuapp.com/rentallock/${date.service_id}/`)
                                  }
                              })
                              postData('https://backendpajamas.herokuapp.com/rentalvanoverride/', {
                                date: ele.date,
                              }).then( responseFinal => {
                                deleteData(`https://backendpajamas.herokuapp.com/eighthour/${ele._id}/`)
                              })
                          })
                      })
                      }
                    }
      
                    // handle the validation page
                    if (ele.locktype === 'https://backendpajamas.herokuapp.com/validationlock/') {
                      let timeDifference = new Date().getTime()-new Date(ele.current_date).getTime()
                      if (timeDifference > 360000*10*8) {
                        putData(`https://backendpajamas.herokuapp.com/validationlock/${ele.lockid}/`, {
                          overriden: false
                        }).then( validationResponse => {
                          deleteData(`https://backendpajamas.herokuapp.com/eighthour/${ele._id}/`)
                        })
                      }
                    }
                  })
                }
                getData('https://backendpajamas.herokuapp.com/managerchange/').then( managerResponse => {
                  if (managerResponse) {
                    managerResponse.results.forEach( ele => {
                      if (parseInt(ele.week_number) !== new Date().getWeek()) {
                        putData(`https://backendpajamas.herokuapp.com/drivers/${ele.driver_id}/`, {
                          location: ele.station
                        }).then( finalDriverResponse => {
                          deleteData(`https://backendpajamas.herokuapp.com/managerchange/${ele._id}/`)
                        })
                      }
                    })
                  }
                })
              })
            }
            myInterval = setInterval( setTime, (60000*30))
        }
        timeFunction()
        getData('https://backendpajamas.herokuapp.com/eighthour/').then( response => {
          if (response) {
            response.results.forEach( ele => {
              // handle the daily service
              if (ele.locktype === 'https://backendpajamas.herokuapp.com/dailyserviceoverridetwo/') {
                let timeDifference = new Date().getTime()-new Date(ele.current_date).getTime()
                if (timeDifference > 360000*10*8) {
                  getData('https://backendpajamas.herokuapp.com/dailyservicelocktwo/').then( response => {
                    getData('https://backendpajamas.herokuapp.com/dailyserviceoverridetwo/').then( responseOverride => {
                        let overrideBool = false
                        responseOverride.results.forEach( date => {
                            if ( date.date === ele.date) {
                              deleteData(`https://backendpajamas.herokuapp.com/dailyserviceoverridetwo/${date.service_id}/`)
                            }
                        })
                        postData('https://backendpajamas.herokuapp.com/dailyservicelocktwo/', {
                          date: ele.date,
                        }).then( responseFinal => {
                          deleteData(`https://backendpajamas.herokuapp.com/eighthour/${ele._id}/`)
                        })
                    })
                })
                }
              }

              // handle the rental van tracker
              if (ele.locktype === 'https://backendpajamas.herokuapp.com/rentalvanoverride/') {
                let timeDifference = new Date().getTime()-new Date(ele.current_date).getTime()
                if (timeDifference > 360000*10*8) {
                  getData('https://backendpajamas.herokuapp.com/rentalvanoverride/').then( response => {
                    getData('https://backendpajamas.herokuapp.com/rentallock/').then( responseOverride => {
                        let overrideBool = false
                        responseOverride.results.forEach( date => {
                            if ( date.date === ele.date) {
                              deleteData(`https://backendpajamas.herokuapp.com/rentallock/${date.service_id}/`)
                            }
                        })
                        postData('https://backendpajamas.herokuapp.com/rentalvanoverride/', {
                          date: ele.date,
                        }).then( responseFinal => {
                          deleteData(`https://backendpajamas.herokuapp.com/eighthour/${ele._id}/`)
                        })
                    })
                })
                }
              }

              // handle the validation page
              if (ele.locktype === 'https://backendpajamas.herokuapp.com/validationlock/') {
                let timeDifference = new Date().getTime()-new Date(ele.current_date).getTime()
                if (timeDifference > 360000*10*8) {
                  putData(`https://backendpajamas.herokuapp.com/validationlock/${ele.lockid}/`, {
                    overriden: false
                  }).then( validationResponse => {
                    deleteData(`https://backendpajamas.herokuapp.com/eighthour/${ele._id}/`)
                  })
                }
              }
            })
          }
          getData('https://backendpajamas.herokuapp.com/managerchange/').then( managerResponse => {
            if (managerResponse) {
              managerResponse.results.forEach( ele => {
                if (parseInt(ele.week_number) !== new Date().getWeek()) {
                  putData(`https://backendpajamas.herokuapp.com/drivers/${ele.driver_id}/`, {
                    location: ele.station
                  }).then( finalDriverResponse => {
                    deleteData(`https://backendpajamas.herokuapp.com/managerchange/${ele._id}/`)
                  })
                }
              })
            }
          })
        })
      }, 3000)
  }, [])


  // Setting state with the user details retrieved using googles Oauth
  const [ userName, setUserName] = useState('')
  const [ userId, setUserId] = useState('')
  const [ userEmail, setUserEmail] = useState('')
  const [ drivers, setDrivers] = useState(null)
  const [ schedule, setSchedule] = useState(null)
  const [ station, setStation ] = useState([])
  const [ userFound, setUserFound ] = useState('')
  const [ superUser, setSuperUser ] = useState(false)
  const [ content, setContent ] = useState(null)

  // // dev login

  useEffect( () => {
    async function getData(url = '', data={}) {
      const response = await fetch(url, {
        method: 'POST', 
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      return response ? response.json() : console.log('no reponse')
    }; 
      async function postData(url = '', data={}) {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
          method: 'POST', 
          mode: 'cors',
          cache: 'no-cache',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${originalText}`
          },
          body: JSON.stringify(data)
        });
        return response ? response.json() : console.log('no reponse')
      }; 
    getData('https://backendpajamas.herokuapp.com/asdjflkasj24dflasd43fhapsdjnfkqjwne2r2oqwiefkasjd43nfkjl4nwe31ofiqwefkjan51dmfnqoweifqk123wjenfaskjdnfasdf/', {
      username: process.env.REACT_APP_DB_USERNAME,
      password: process.env.REACT_APP_DB_PASSWORD
    }).then( (responseInitial) => {
      let encryptedToken = CryptoJS.AES.encrypt(responseInitial.token.toString(), process.env.REACT_APP_ENCRYPTION_TYPE).toString()
      localStorage.setItem('token', encryptedToken)
      // postData('https://backendpajamas.herokuapp.com/trackeradditions/', {
      //   date: new Date().toDateString(),
      //   manager_id: '1b9cb0ba-74f6-47da-90e9-a40315fb9d7d',
      //   logIn_time: [new Date().toDateString()],
      //   latitude: userObj.lat,
      //   longitude: userObj.long
      // }).then( newLoginResponse => {
        // console.log(newLoginResponse)
        // i.stoykov@h2ologistics.co.uk
        // Compliance@h2ologistics.co.uk
      setUserName('guest')
      setUserEmail('guest@h2ologistics.co.uk')
      setUserId('1b9cb0ba-74f6-47da-90e9-a40315fb9d7d')
      setSuperUser(true)
      // })
      // setStation(['DBS2', 'DSN1', 'DXP1'])
    })
  }, [])

  // comment

  // handles writting data to database and recieving google data
  const responseGoogle = (responseGoog) => {
    // commentrar
    // function for displaying list of stations
    if (responseGoog) {
      async function getDataNext(url = '') {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'GET', 
            mode: 'cors', 
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Token ${originalText}`
            }
        });
        return response ? response.json() : console.log('no reponse')
      };

      async function postInitial(url = '', data={}) {
        const response = await fetch(url, {
            method: 'POST', 
            mode: 'cors', 
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return response ? response.json() : console.log('no reponse')
      };
        async function getData(url = '', data={}) {
          let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
          let originalText = bytes.toString(CryptoJS.enc.Utf8);
          const response = await fetch(url, { 
              method: 'POST', 
              mode: 'cors',
              cache: 'no-cache',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
              },
              body: JSON.stringify(data)
          });
          return response ? response.json() : console.log('no reponse')
        }; 
        async function putData(url = '', data={}) {
          let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
          let originalText = bytes.toString(CryptoJS.enc.Utf8);
          const response = await fetch(url, { 
              method: 'PUT', 
              mode: 'cors',
              cache: 'no-cache',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
              },
              body: JSON.stringify(data)
          });
          return response ? response.json() : console.log('no reponse')
        }; 
      
      if (responseGoog.profileObj.email === process.env.REACT_APP_EMAIL_VERIFICATION || responseGoog.profileObj.email === 'shanky2967@gmail.com' ||responseGoog.profileObj.email === process.env.REACT_APP_SUPER_USER || responseGoog.profileObj.email === 'gigiilieva17g@gmail.com' || responseGoog.profileObj.email.includes('h2ologistics.co.uk')) {
        // try {
        //   axios.get('https://geolocation-db.com/json/344ec440-6bfc-11eb-a0c0-b5dee9e67313').then( responseLatitude => {
        //     let responselat = 0
        //     let responselong = 0
        //     if (responseLatitude.status === 200) {
        //       responselat = responseLatitude.data.latitude
        //       responselong = responseLatitude.data.longitude
        //     }
        //       // access backend initialed
        //     postInitial('https://backendpajamas.herokuapp.com/asdjflkasj24dflasd43fhapsdjnfkqjwne2r2oqwiefkasjd43nfkjl4nwe31ofiqwefkjan51dmfnqoweifqk123wjenfaskjdnfasdf/', {
        //       username: process.env.REACT_APP_DB_USERNAME,
        //       password: process.env.REACT_APP_DB_PASSWORD
        //     }).then( (response) => {
        //       let theDate = new Date()
        //       let theTime = `${theDate.getHours()}:${theDate.getMinutes()}:${theDate.getSeconds()}`
        //       let localTimeArray = [theTime]
        //       let encryptedToken = CryptoJS.AES.encrypt(response.token.toString(), process.env.REACT_APP_ENCRYPTION_TYPE).toString()
        //       localStorage.setItem('token', encryptedToken)
        //       // handleRequests()
        //       if (responseGoog.profileObj.email === process.env.REACT_APP_EMAIL_VERIFICATION || responseGoog.profileObj.email === process.env.REACT_APP_SUPER_USER || responseGoog.profileObj.email === 'gigiilieva17g@gmail.com' || responseGoog.profileObj.email === 'yanaki@h2ologistics.co.uk' || responseGoog.profileObj.email === 'ginoveva@h2ologistics.co.uk' || responseGoog.profileObj.email === 'Compliance@h2ologistics.co.uk' || responseGoog.profileObj.email === 'compliance@h2ologistics.co.uk') {
        //         if (responseGoog.profileObj.email === 'Compliance@h2ologistics.co.uk' || responseGoog.profileObj.email === 'compliance@h2ologistics.co.uk') {
        //           setUserName('Nina Pavlova')
        //           setUserId('2a4d70fb-58b2-4ba9-bc3d-3721a22a177c')
        //           setUserEmail('Compliance@h2ologistics.co.uk')
        //           userObj.name = 'Nina Pavlova'
        //           userObj.email = 'compliance@h2ologistics.co.uk'
        //           userObj.id = '2a4d70fb-58b2-4ba9-bc3d-3721a22a177c'
        //           userObj.logOut = response.logOut_time
        //           setStation(['DBS2', 'DEX2', 'DSN1', 'DXP1', 'DCF1'])
        //         } else {
        //           setUserName(responseGoog.profileObj.givenName)
        //           setUserId(responseGoog.profileObj.givenName)
        //           setUserEmail(responseGoog.profileObj.email)
        //           setSuperUser(true)
        //           userObj.name = responseGoog.profileObj.givenName
        //           userObj.email = responseGoog.profileObj.email
        //           userObj.id = responseGoog.profileObj.givenName
        //           userObj.logOut = response.logOut_time
        //           userObj.super = true
        //         }
        //       } else {
        //         // eslint-disable-next-line no-unused-vars
        //         getDataNext('https://backendpajamas.herokuapp.com/managers/').then( response => {
        //           let localVar = 0
        //           let thisVar = 0
        //           const stationDisplay = (user) => {
        //             let stationList = []
        //             user.DBS2 ? stationList.push('DBS2') : console.log('none');
        //             user.DEX2 ? stationList.push('DEX2') : console.log('none');
        //             user.DSN1 ? stationList.push('DSN1') : console.log('none');
        //             user.DXP1 ? stationList.push('DXP1') : console.log('none');
        //             user.DCF1 ? stationList.push('DCF1') : console.log('none');
        //             return stationList
        //           }
        //           response.results.forEach( ele => {
        //             if (responseGoog.profileObj.email === ele.email) {
        //               getData('https://backendpajamas.herokuapp.com/tracker/', {
        //                 ID: ele.user_id
        //               }).then( responseTracker => {
        //                 if (responseTracker.data.length > 0) {
        //                   let localBool = false
        //                   responseTracker.data.forEach( responseEle => {
        //                     if (responseEle.date === new Date().toDateString()) {
        //                       localBool = true
        //                       let localNewTimeArray = [...responseEle.logIn_time, theTime]
        //                       putNext(`https://backendpajamas.herokuapp.com/trackeradditions/${responseEle._id}/`, {
        //                         logIn_time: localNewTimeArray
        //                       }).then( response => { 
        //                         // handleRequests()
        //                         setUserName(responseGoog.profileObj.givenName)
        //                         setUserId(ele.user_id)
        //                         setUserEmail(responseGoog.profileObj.email)
        //                         setStation(stationDisplay(ele))
                                
        //                         userObj.name = responseGoog.profileObj.givenName
        //                         userObj.email = responseGoog.profileObj.email
        //                         userObj.id = ele.user_id
        //                         userObj.logOut = response.logOut_time
        //                         localVar = 1
        //                       })
        //                     }
        //                   })
        //                   if (!localBool) {
        //                     getData('https://backendpajamas.herokuapp.com/trackeradditions/', {
        //                       date: new Date().toDateString(),
        //                       manager_id: ele.user_id,
        //                       logIn_time: localTimeArray,
        //                       latitude: responselat,
        //                       longitude: responselong
        //                     }).then( newLoginResponse => {
        //                       setUserName(responseGoog.profileObj.givenName)
        //                       setUserId(ele.user_id)
        //                       setUserEmail(responseGoog.profileObj.email)
        //                       setStation(stationDisplay(ele))
                              
        //                       userObj.name = responseGoog.profileObj.givenName
        //                       userObj.email = responseGoog.profileObj.email
        //                       userObj.id = ele.user_id
        //                       userObj.logOut = response.logOut_time
        //                       userObj.logOut = newLoginResponse.logOut_time
        //                       localVar = 1
        //                     })
        //                   }
        //                 } else {
        //                   getData('https://backendpajamas.herokuapp.com/trackeradditions/', {
        //                     date: new Date().toDateString(),
        //                     manager_id: ele.user_id,
        //                     logIn_time: localTimeArray,
        //                     latitude: 0,
        //                     longitude: 0
        //                   }).then( newLoginResponse => {
        //                     setUserName(responseGoog.profileObj.givenName)
        //                     setUserId(ele.user_id)
        //                     setUserEmail(responseGoog.profileObj.email)
        //                     setStation(stationDisplay(ele))
                            
        //                     userObj.name = responseGoog.profileObj.givenName
        //                     userObj.email = responseGoog.profileObj.email
        //                     userObj.id = ele.user_id
        //                     userObj.logOut = response.logOut_time
        //                     userObj.logOut = newLoginResponse.logOut_time
        //                     localVar = 1
        //                   })
        //                 }
        //               })
        //             }
        //           })
        //           if (localVar === 0) {
        //             setUserFound('Login not found. Please contact site administrator')
        //           }
        //         })
        //       }
        //     })
        //   })
        // } catch ( error) {
          // console.log(error)
          // access backend initialed 
          postInitial('https://backendpajamas.herokuapp.com/asdjflkasj24dflasd43fhapsdjnfkqjwne2r2oqwiefkasjd43nfkjl4nwe31ofiqwefkjan51dmfnqoweifqk123wjenfaskjdnfasdf/', {
            username: process.env.REACT_APP_DB_USERNAME,
            password: process.env.REACT_APP_DB_PASSWORD
          }).then( (response) => {
            let theDate = new Date()
            let theTime = `${theDate.getHours()}:${theDate.getMinutes()}:${theDate.getSeconds()}`
            let localTimeArray = [theTime]
            let encryptedToken = CryptoJS.AES.encrypt(response.token.toString(), process.env.REACT_APP_ENCRYPTION_TYPE).toString()
            localStorage.setItem('token', encryptedToken)
            // handleRequests()
            if (responseGoog.profileObj.email === process.env.REACT_APP_EMAIL_VERIFICATION || responseGoog.profileObj.email === process.env.REACT_APP_SUPER_USER || responseGoog.profileObj.email === 'gigiilieva17g@gmail.com' || responseGoog.profileObj.email === 'yanaki@h2ologistics.co.uk' || responseGoog.profileObj.email === 'ginoveva@h2ologistics.co.uk' || responseGoog.profileObj.email === 'Compliance@h2ologistics.co.uk' || responseGoog.profileObj.email === 'compliance@h2ologistics.co.uk' || responseGoog.profileObj.email === 'invoices@h2ologistics.co.uk') {
              if (responseGoog.profileObj.email === 'Compliance@h2ologistics.co.uk' || responseGoog.profileObj.email === 'compliance@h2ologistics.co.uk') {
                setUserName('Nina Pavlova')
                setUserId('2a4d70fb-58b2-4ba9-bc3d-3721a22a177c')
                setUserEmail('Compliance@h2ologistics.co.uk')
                userObj.name = 'Nina Pavlova'
                userObj.email = 'compliance@h2ologistics.co.uk'
                userObj.id = '2a4d70fb-58b2-4ba9-bc3d-3721a22a177c'
                userObj.logOut = response.logOut_time
                setStation(['DBS2', 'DEX2', 'DSN1', 'DXP1', 'DCF1'])
              } else {
                setUserName(responseGoog.profileObj.givenName)
                setUserId(responseGoog.profileObj.givenName)
                setUserEmail(responseGoog.profileObj.email)
                setSuperUser(true)
                userObj.name = responseGoog.profileObj.givenName
                userObj.email = responseGoog.profileObj.email
                userObj.id = responseGoog.profileObj.givenName
                userObj.logOut = response.logOut_time
                userObj.super = true
              }
            } else {
              // eslint-disable-next-line no-unused-vars
              getDataNext('https://backendpajamas.herokuapp.com/managers/').then( response => {
                let localVar = 0
                let thisVar = 0
                const stationDisplay = (user) => {
                  let stationList = []
                  user.DBS2 ? stationList.push('DBS2') : console.log('none');
                  user.DEX2 ? stationList.push('DEX2') : console.log('none');
                  user.DSN1 ? stationList.push('DSN1') : console.log('none');
                  user.DXP1 ? stationList.push('DXP1') : console.log('none');
                  user.DCF1 ? stationList.push('DCF1') : console.log('none');
                  return stationList
                }
                response.results.forEach( ele => {
                  if (responseGoog.profileObj.email === ele.email) {
                    getData('https://backendpajamas.herokuapp.com/tracker/', {
                      ID: ele.user_id
                    }).then( responseTracker => {
                      if (responseTracker.data.length > 0) {
                        let localBool = false
                        responseTracker.data.forEach( responseEle => {
                          if (responseEle.date === new Date().toDateString()) {
                            localBool = true
                            let localNewTimeArray = [...responseEle.logIn_time, theTime]
                            putNext(`https://backendpajamas.herokuapp.com/trackeradditions/${responseEle._id}/`, {
                              logIn_time: localNewTimeArray
                            }).then( response => { 
                              // handleRequests()
                              setUserName(responseGoog.profileObj.givenName)
                              setUserId(ele.user_id)
                              setUserEmail(responseGoog.profileObj.email)
                              setStation(stationDisplay(ele))
                              
                              userObj.name = responseGoog.profileObj.givenName
                              userObj.email = responseGoog.profileObj.email
                              userObj.id = ele.user_id
                              userObj.logOut = response.logOut_time
                              localVar = 1
                            })
                          }
                        })
                        if (!localBool) {
                          getData('https://backendpajamas.herokuapp.com/trackeradditions/', {
                            date: new Date().toDateString(),
                            manager_id: ele.user_id,
                            logIn_time: localTimeArray,
                            latitude: 0,
                            longitude: 0
                          }).then( newLoginResponse => {
                            setUserName(responseGoog.profileObj.givenName)
                            setUserId(ele.user_id)
                            setUserEmail(responseGoog.profileObj.email)
                            setStation(stationDisplay(ele))
                            
                            userObj.name = responseGoog.profileObj.givenName
                            userObj.email = responseGoog.profileObj.email
                            userObj.id = ele.user_id
                            userObj.logOut = response.logOut_time
                            userObj.logOut = newLoginResponse.logOut_time
                            localVar = 1
                          })
                        }
                      } else {
                        getData('https://backendpajamas.herokuapp.com/trackeradditions/', {
                          date: new Date().toDateString(),
                          manager_id: ele.user_id,
                          logIn_time: localTimeArray,
                          latitude: 0,
                          longitude: 0
                        }).then( newLoginResponse => {
                          setUserName(responseGoog.profileObj.givenName)
                          setUserId(ele.user_id)
                          setUserEmail(responseGoog.profileObj.email)
                          setStation(stationDisplay(ele))
                          
                          userObj.name = responseGoog.profileObj.givenName
                          userObj.email = responseGoog.profileObj.email
                          userObj.id = ele.user_id
                          userObj.logOut = response.logOut_time
                          userObj.logOut = newLoginResponse.logOut_time
                          localVar = 1
                        })
                      }
                    })
                  }
                })
                if (localVar === 0) {
                  setUserFound('Login not found. Please contact site administrator')
                }
              })
            }
          })
        // }
      }
    }
  }

  // a comment

  useEffect( () => {
    // if (superUser) {
      setContent(
        <Router >
          <Route exact path = '/' render={ () => <Home user_name={userName} user_email={userEmail} user_id={userId} superUser={true}/> } />
          <Route exact path = '/manager' render={ () => <CreateManager user_name={userName} user_email={userEmail} user_id={userId}  superUser={true}/> } />
          <Route exact path = '/home' render={ () => <HomeTwo user_name={userName} user_email={userEmail} user_id={userId} superUser={true} />  } />
          <Route exact path = '/makemployee' render={ () => <MakeEmployee user_name={userName} user_email={userEmail} user_id={userName} superUser={true}/> } />
          <Route exact path = '/reports' render={ () => <Reports user_name={userName} user_email={userEmail} user_id={userId} superUser={true}/> } />
          <Route exact path = '/weekschedule' render={ () => <WeekSchedule user_name={userName} user_email={userEmail} superUser={true} user_id={userName}/> } />
          <Route exact path = '/driver/:id/:date' render={ () => <Driver user_name={userName} user_email={userEmail} driver_data={drivers} schedule_data={schedule} superUser={true} user_id={userName}/> } />
          <Route exact path = '/dashboard' render={ () => <Dashboard user_name={userName} user_email={userEmail} superUser={true} user_id={userName}/> } />
          <Route exact path = '/summary' render={ () => <Summary user_name={userName} user_email={userEmail} superUser={true} user_id={userName}/> } />
          <Route exact path = '/validation' render={ () => <Statistics user_name={userName} user_email={userEmail} superUser={true} user_id={userName}/> } />
          <Route exact path = '/forms' render={ () => <Forms user_name={userName} user_email={userEmail} superUser={true} user_id={userName}/> } />
          <Route exact path = '/documentsforverification' render={ () => <DocumentsForVerification user_name={userName} user_email={userEmail} superUser={true} user_id={userName}/> } />
          <Route exact path = '/driverdocuments' render={ () => <DriverDocuments user_name={userName} user_email={userEmail} superUser={true} user_id={userName}/> } />
          <Route exact path = '/companyvans' render={ () => <CompanyVans user_name={userName} user_email={userEmail} superUser={true} user_id={userName}/> } />
          <Route exact path = '/rentalvantracker' render={ () => <RentalVanTracker user_name={userName} user_email={userEmail} superUser={true} user_id={userName}/> } />
          <Route exact path = '/compliance' render={ () => <Compliance user_name={userName} user_email={userEmail} superUser={true} user_id={userName}/> } />
          <Route exact path = '/drivercompliancecheck' render={ () => <DriverComplianceCheck user_name={userName} user_email={userEmail} superUser={true} user_id={userName}/> } />
          <Route exact path = '/invoicework' render={ () => <InvoiceWork user_name={userName} user_email={userEmail} superUser={true} user_id={userName}/> } />
          <Route exact path = '/singleday/:id/:location' render={ () => <SingleDay user_name={userName} user_email={userEmail} superUser={true} user_id={userName}/> } />
        </Router>
      )
    // } else if (userId) {
    //   setContent(
    //     <Router>
    //       <Route exact path = '/' render={ () => <Home user_name={userName} user_email={userEmail} user_id={userId} station={station} /> } />
    //       <Route exact path = '/home' render={ () => <HomeTwo user_name={userName} user_email={userEmail} user_id={userId} station={station}/>}>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route>
    //       <Route exact path = '/makemployee' render={ () => <MakeEmployee user_name={userName} user_email={userEmail} user_id={userId} station={station}/> }>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route>  
    //       <Route exact path = '/weekschedule' render={ () => <WeekSchedule user_name={userName} user_email={userEmail} station={station} user_id={userId}/> }>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route> 
    //       <Route exact path = '/driver/:id/:date' render={ () => <Driver user_name={userName} user_email={userEmail} driver_data={drivers} schedule_data={schedule} user_id={userId} station={station}/> }>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route> 
    //       <Route exact path = '/dashboard' render={ () => <Dashboard user_name={userName} user_email={userEmail} station={station} user_id={userId}/> }>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route> 
    //       <Route exact path = '/validation' render={ () => <Statistics user_name={userName} user_email={userEmail} station={station} user_id={userId}/> }>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route> 
    //       <Route exact path = '/forms' render={ () => <Forms user_name={userName} user_email={userEmail} station={station} user_id={userId}/> }>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route> 
    //       <Route exact path = '/documentsforverification' render={ () => <DocumentsForVerification user_name={userName} user_email={userEmail} station={station} user_id={userId}/> }>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route> 
    //       <Route exact path = '/summary' render={ () => <Summary user_name={userName} user_email={userEmail} station={station} user_id={userId}/> }>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route> 
    //       <Route exact path = '/driverdocuments' render={ () => <DriverDocuments user_name={userName} user_email={userEmail} station={station} user_id={userId}/> }>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route> 
    //       <Route exact path = '/companyvans' render={ () => <CompanyVans user_name={userName} user_email={userEmail} station={station} user_id={userId}/> }>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route> 
    //       <Route exact path = '/compliance' render={ () => <Compliance user_name={userName} user_email={userEmail} station={station} user_id={userId}/> }>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route> 
    //       <Route exact path = '/rentalvantracker' render={ () => <RentalVanTracker user_name={userName} user_email={userEmail} station={station} user_id={userId}/> }>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route> 
    //       <Route exact path = '/drivercompliancecheck' render={ () => <DriverComplianceCheck user_name={userName} user_email={userEmail} station={station} user_id={userId}/> }>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route> 
    //       <Route exact path = '/invoicework' render={ () => <InvoiceWork user_name={userName} user_email={userEmail} station={station} user_id={userId}/> }>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route> 
    //       <Route exact path = '/singleday/:id/:location' render={ () => <SingleDay user_name={userName} user_email={userEmail} station={station} user_id={userId}/> }>
    //         {userId ? console.log('') : <Redirect to="/" />}
    //       </Route> 
    //     </Router>
    //   )
    // }
    //  else if (userFound) {
    //   setContent(
    //     <div className="landingPage">
    //       <img src={logo} alt="Logo" className='welcome_screen_logo'/>
    //       <div className='google_log_in_container'>
    //         {userFound}
    //       </div>
    //     </div >
    //   )
    // }
    //  else {
    //   setContent(
    //     <div className="landingPage">
    //       <img src={logo} alt="Logo" className='welcome_screen_logo'/>
    //       <div className='google_log_in_container'>
    //         <GoogleLogin
    //           clientId='175290320384-sb9u1a47qf7isbk6n55gmscmgbosm3c0.apps.googleusercontent.com'
    //           render={renderProps => (
    //             <button className='front_page_button' onClick={renderProps.onClick}>
    //               <span className='span_in_front_page_button'>Login</span> 
    //             </button>
    //           )}
    //           onSuccess={responseGoogle}
    //           onFailure={responseGoogle}
    //           cookiePolicy={'single_host_origin'}
    //         />
    //       </div>
    //     </div >
    //   )
    // }  
    // userId, userEmail, userFound, superUser, station
  }, [userId, userEmail, userFound, superUser, station])
  
  return (
    <>
      <div className='versionNumber'>
        version 2.6.2
      </div>
      {content}
    </>
  );
}

export default App;
